<template>
  <b-modal
    centered
    id="edit-onboard"
    modal-class="overflow-hidden"
    static
    scrollable
    @hidden="onHidden"
  >
    <template #modal-header="{ close }">
      <h5>Sửa PA onboard</h5>
      <b-button size="sm" variant="light" @click="close()"> x </b-button>
    </template>
    <div>
      <div class="form-group">
        <label>Tên</label>
        <input :value="dataOnboard.name" disabled />
      </div>
      <div class="form-group">
        <label>Cấp</label>
        <input :value="dataOnboard.level" disabled />
      </div>
      <div class="form-group">
        <label>Phương án onboard</label>
        <Select2
          v-model="onboardMerchant"
          :options="Config.onboardPlan"
          placeholder="Chọn phương án onboard"
        >
        </Select2>
      </div>
    </div>
    <template #modal-footer="{ cancel }">
      <b-button size="sm" variant="light" @click="cancel()"> Hủy </b-button>
      <b-button size="sm" variant="primary" @click="update"> Lưu </b-button>
    </template>
  </b-modal>
</template>

<script>
  import Config from '@/thirdParty/config'
  export default {
    props: {
      dataOnboard: {
        type: Object,
        default: () => ({}),
      },
    },
    data() {
      return {
        Config,
        onboardMerchant: '',
      }
    },
    methods: {
      async update() {
        const data = {
          id: this.dataOnboard.id,
          onboardMerchant: this.onboardMerchant,
        }
        this.$emit('update', data)
      },
      onHidden() {
        this.$emit('onHidden')
      },
    },
  }
</script>

<style scoped></style>
